import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import { INPUT_VARIANT } from "@/common/elements/InputElements/const";
import Button from "@/common/elements/Button";
import Modal from "@/common/elements/Modal";
import _ from "lodash";
import { useEffect, useState } from "react";
import { FormContainer } from "../InmateDetails/styles";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import {
  StyledGridCol,
  StyledGridRow,
  StyledSectionHeading,
} from "@/common/styles";
import { Checkbox, Form } from "antd";
import dayjs from "dayjs";
import CommonDatePicker from "@/common/elements/DatePicker";
import {
  getDayjsObject,
  getOptionsFromRefList,
  isNonEmptyVariable,
} from "@/util/common_function";

export const MODE = { NEW: "NEW", EDIT: "EDIT" };

const validateData = (data) => {
  return { isValid: true, errors: [] };
};

const ChargesInformationModal = ({
  show,
  onHide,
  mode = MODE.NEW,
  selectChargeInfo,
  forwardSave,
}) => {
  const [form] = Form.useForm();
  const [chargeInfo, setChargeInfo] = useState(null);

  useEffect(() => {
    if (isNonEmptyVariable(selectChargeInfo)) {
      setChargeInfo(() => ({
        ...selectChargeInfo,
        offenseDate: selectChargeInfo?.offenseDate
          ? dayjs(selectChargeInfo?.offenseDate)
          : null,
        clearanceDateTime: getDayjsObject(
          selectChargeInfo?.clearanceDate,
          selectChargeInfo?.clearanceTime
        ),
        scheduledReleaseDateTime: getDayjsObject(
          selectChargeInfo?.scheduledReleaseDate,
          selectChargeInfo?.scheduledReleaseTime
        ),
      }));
    } else {
      setChargeInfo(null);
    }
  }, [selectChargeInfo]);

  useEffect(() => {
    if (isNonEmptyVariable(chargeInfo)) {
      form.setFieldsValue(chargeInfo);
    } else {
      form.resetFields();
    }
  }, [chargeInfo]);


  const onModalHide = () => {
    onHide();
  };

  const onChargesInformationSaveClick = () => {
    const values = form.getFieldsValue();
    // offenseDate: only date
    if (values.offenseDate && typeof values.offenseDate.format === 'function') {
      values.offenseDate = values.offenseDate.format("MM/DD/YYYY");
    }
    // scheduledReleaseDateTime: split into date and time
    if (values.scheduledReleaseDateTime && typeof values.scheduledReleaseDateTime.format === 'function') {
      const dt = values.scheduledReleaseDateTime;
      values.scheduledReleaseDate = dt.format("MM/DD/YYYY");
      values.scheduledReleaseTime = dt.format("HH:mm");
      delete values.scheduledReleaseDateTime;
    }
    // clearanceDateTime: split into date and time
    if (values.clearanceDateTime && typeof values.clearanceDateTime.format === 'function') {
      const dt = values.clearanceDateTime;
      values.clearanceDate = dt.format("MM/DD/YYYY");
      values.clearanceTime = dt.format("HH:mm");
      delete values.clearanceDateTime;
    }
    forwardSave(values, selectChargeInfo?.id);
    onHide();
  };

  return (
    <>
      <Modal
        show={show}
        onHide={onModalHide}
        designPattern="ant"
        header="Detention Charge Details"
        width="50%"
        footerActionsNeed={true}
        footerActions={[
          <Button key="save" type="primary" onClick={onChargesInformationSaveClick}>Save</Button>,
          <Button key="cancel" onClick={onModalHide}>Cancel</Button>
        ]}
      >
        <FormContainer>
          <Form form={form} initialValues={chargeInfo}>
            <StyledSectionHeading>
              <span>Charge Information</span>
            </StyledSectionHeading>
            <StyledGridRow justify="end">
              <StyledGridCol>
                <FormItem
                  label="Sealed?"
                  layout="horizontal"
                  labelPostion="label-right"
                >
                  <Checkbox name="sealed" />
                </FormItem>
              </StyledGridCol>
            </StyledGridRow>
            <StyledGridRow gutter={16}>
              <StyledGridCol lg={12}>
                <FormItem name="chargeDescriptionID" label="Charge">
                  <Select
                    options={getOptionsFromRefList(
                      "Charges",
                      false,
                      false,
                      true
                    )}
                    placeholder="Charge"
                    showSearch={false}
                    variant="outlined"
                  />
                </FormItem>
              </StyledGridCol>

              <StyledGridCol lg={6}>
                <FormItem name="ucrCode" label="Code">
                  <TextField />
                </FormItem>
              </StyledGridCol>
              <StyledGridCol lg={6}>
                <FormItem name="chargeLevelID" label="Level">
                  <Select
                    options={getOptionsFromRefList(
                      "Charge_Level",
                      false,
                      false,
                      true
                    )}
                    placeholder="Level"
                    showSearch={false}
                    variant="outlined"
                  />
                </FormItem>
              </StyledGridCol>
              <StyledGridCol lg={8}>
                <FormItem name="offenseDate" label="Offense Date">
                  <CommonDatePicker
                    placeholder="MM/DD/YYYY"
                    format="MM/DD/YYYY"
                    showTime={false}
                  />
                </FormItem>
              </StyledGridCol>
              <StyledGridCol lg={8}>
                <FormItem
                  name="scheduledReleaseDateTime"
                  label="Scheduled Release"
                >
                  <CommonDatePicker
                    placeholder="MM/DD/YYYY HH:mm"
                    showTime={true}
                  />
                </FormItem>
              </StyledGridCol>
            </StyledGridRow>

            <StyledSectionHeading>
              <span>Clearance Information</span>
            </StyledSectionHeading>
            <StyledGridRow gutter={16}>
              <StyledGridCol lg={8}>
                <FormItem name="clearanceDateTime" label="Date/Time">
                  <CommonDatePicker />
                </FormItem>
              </StyledGridCol>
              <StyledGridCol lg={8}>
                <FormItem name="clearanceReasonID" label="Reason">
                  <Select
                    options={getOptionsFromRefList(
                      "ChargeClearance",
                      false,
                      false,
                      true
                    )}
                  />
                </FormItem>
              </StyledGridCol>
            </StyledGridRow>
          </Form>
        </FormContainer>
      </Modal>
    </>
  );
};

export default ChargesInformationModal;
